export enum PlatformSesionSelector {
  currentPlatform = 'currentPlatform'
}
